import { render, staticRenderFns } from "./confirmContent.vue?vue&type=template&id=f622fcf0&scoped=true"
import script from "./confirmContent.vue?vue&type=script&lang=js"
export * from "./confirmContent.vue?vue&type=script&lang=js"
import style0 from "./confirmContent.vue?vue&type=style&index=0&id=f622fcf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f622fcf0",
  null
  
)

export default component.exports